import React from 'react'
import { ArrayInput, RaRecord, SimpleFormIterator } from 'react-admin'
import BriefQuestionInput from './BriefQuestionInput'

type Props = {
  source: string
  isGeneralQuestion?: boolean
  productChoices?: RaRecord[]
}

const BriefQuestionArrayInput: React.FC<Props> = ({
  source,
  isGeneralQuestion = false,
  productChoices,
}) => {
  return (
    <ArrayInput
      source={source}
      label="Survey Structure"
      style={{ padding: '16px 0' }}
    >
      <SimpleFormIterator>
        <BriefQuestionInput
          isGeneralQuestion={isGeneralQuestion}
          productChoices={productChoices}
        />
      </SimpleFormIterator>
    </ArrayInput>
  )
}

export default BriefQuestionArrayInput
